<input type="file" [accept]="accept" (change)="fileChanged($event)">